import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import GalleryGrid from '../components/GalleryGrid';

export default function MechanicalEngineering() {
  const galleryImages = [
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/mekanisk-konstruktion-cad.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/2dee4a-01b2b211d5ea4244916831dd44ab4a7b-mv2.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/2dee4a-f13a7513b1d94a9ca64d009f1172fcf7-mv2.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/produktionsudstyr-specialmaskine.jpg',
  ];

  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-screen">
      <SEO
        title="Mekanisk konstruktion - JARCon ApS"
        description="Udvikling og konstruktion af maskiner og maskindele samt freelance konstruktion. 2D/3D Inventor, NX og Creo samt FEM analyse."
      />

      <PageHeader
        badge="Konsulentydelser"
        title="Mekanisk konstruktion"
        subtitle="Udvikling og konstruktion af maskiner og maskindele • Freelance konstruktion"
        breadcrumbs={[
          { label: 'Konsulentydelser', path: '/konsulentydelser' },
          { label: 'Mekanisk konstruktion' },
        ]}
        ctaText="Tal med os om dit projekt"
        ctaLink="/kontakt"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Main content */}
          <div className="lg:col-span-8 space-y-8">
            <div className="p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest font-semibold block">
                Faktisk kompetenceprofil
              </span>
              <h2 className="font-display text-2xl font-bold text-white">
                Udvikling og maskinkonstruktion
              </h2>
              <p className="text-slate-300 text-base leading-relaxed">
                Udvikling og konstruktion af maskiner og maskindele samt freelance konstruktion tilpasset maskinbyggere, produktionsvirksomheder og udviklingsafdelinger.
              </p>
              <p className="text-slate-400 text-sm leading-relaxed">
                Med solid erfaring fra maskinbranchen sikrer JARCon robuste mekaniske løsninger, hvor der er taget højde for fremstilling, montage, tolerancer og vedligeholdelse.
              </p>
            </div>

            {/* Technical CAD details */}
            <div className="p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
              <h3 className="font-display text-xl font-bold text-white flex items-center gap-2">
                <i className="fa-solid fa-cube text-cyan-400 text-base" aria-hidden="true" />
                CAD design og FEM (Finite Elemente Analyse)
              </h3>
              <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
                2D/3D tegning og Finite Elemente Analyse. Vi tegner i Autodesk Inventor, men kan også tegne i Siemens NX og PTC Creo.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4">
                <div className="p-4 rounded-lg bg-[#080d14] border border-slate-800 font-open-sans text-xs">
                  <span className="text-cyan-400 font-semibold block mb-1">Inventor</span>
                  <span className="text-slate-400">Primært CAD værktøj til 3D parter, samlinger og tegninger</span>
                </div>
                <div className="p-4 rounded-lg bg-[#080d14] border border-slate-800 font-open-sans text-xs">
                  <span className="text-cyan-400 font-semibold block mb-1">Siemens NX</span>
                  <span className="text-slate-400">Komplekse geometrier og avanceret overflademodellering</span>
                </div>
                <div className="p-4 rounded-lg bg-[#080d14] border border-slate-800 font-open-sans text-xs">
                  <span className="text-cyan-400 font-semibold block mb-1">PTC Creo</span>
                  <span className="text-slate-400">Parametrisk modellering og industrielt design</span>
                </div>
              </div>
            </div>

            {/* Gallery */}
            <GalleryGrid
              title="Mekanisk konstruktion galleri"
              subtitle="Klik på billederne for at åbne i fuld skærm"
              images={galleryImages}
            />
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-4 space-y-6">
            <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
              <h3 className="font-display text-base font-bold text-white mb-4 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-cyan-400" />
                Nøglepunkter
              </h3>
              <ul className="space-y-3 text-xs font-open-sans text-slate-300">
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-cyan-400 mt-0.5" aria-hidden="true" />
                  <span>Udvikling og maskinkonstruktion</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-cyan-400 mt-0.5" aria-hidden="true" />
                  <span>Maskindele og delkomponenter</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-cyan-400 mt-0.5" aria-hidden="true" />
                  <span>Freelance konstruktion</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-cyan-400 mt-0.5" aria-hidden="true" />
                  <span>2D/3D tegning</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-cyan-400 mt-0.5" aria-hidden="true" />
                  <span>Finite Elemente Analyse (FEM)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-cyan-400 mt-0.5" aria-hidden="true" />
                  <span>Tegner i Inventor, NX og Creo</span>
                </li>
              </ul>
            </div>

            <div className="p-6 rounded-xl bg-gradient-to-br from-[#0e1622] to-[#070b10] border border-cyan-500/40 text-center space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-wider block font-semibold">
                Brug for assistance?
              </span>
              <h4 className="font-display font-bold text-lg text-white">
                Få en teknisk vurdering af dit projekt
              </h4>
              <p className="text-xs text-slate-300">
                Ring direkte til Jens Christensen på +45 22 88 45 36 for en uforpligtende dialog.
              </p>
              <Link
                to="/kontakt"
                className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-xs uppercase tracking-wider transition-all"
              >
                <span>Kontakt os</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
